import { render } from "./YoutubeTag.vue?vue&type=template&id=326d3855&scoped=true"
const script = {}

import "./YoutubeTag.vue?vue&type=style&index=0&id=326d3855&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326d3855"]])

export default __exports__